import React, { memo } from "react";

import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import blogsStyle from "assets/jss/trip-kit/views/sectionsSections/blogsStyle.js";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import { useMediaQuery }  from "react-responsive";

const useStyles = makeStyles(blogsStyle);

const MainContentsItem = memo(({type,contenttypeid,contentid, mainImage,mainTitle, mainAddr, lang,title}) => {
  const isPad = useMediaQuery({
    query : "(min-width: 600px) and (max-width: 1199px)"
  })
  const subStrTxt = (txt,len) => {
    if (txt.length > len) {
      txt = txt.substr(0, len) + '...';
    }
    return txt;
  }
  
    const classes = useStyles();
    return (
      <GridItem xs={12} sm={4} md={4} style={{paddingBottom:"10px"}}>
        <Card plain blog>  
          
          <Link to={`/${type}/${contenttypeid}/${contentid}?local=${lang}`}>
              <CardHeader plain image>
              <LazyLoadImage  width={"100%"} height={"254px"}  effect="blur" src={mainImage ? mainImage : "https://www.tripcheckiner.com/no-image-icon.jpg"} alt={mainTitle}/>

                  {/* 
              <div className={classes.coloredShadow}
                  style={{
                  backgroundImage: `url(${content.firstimage ? content.firstimage.replace('http:', 'https:') : "https://www.tripcheckiner.com/no-image-icon.jpg"})`,
                  opacity: "1"
                  }}
              />*/}
              </CardHeader>
              {
                <CardBody plain>
                <h4 className={classes.cardTitle2}>{mainTitle ? subStrTxt(mainTitle,isPad ? 38 : 55) : ""}</h4>
                <h6 style={{color:"#a2a2a2"}}>{mainAddr ? subStrTxt(mainAddr,isPad ? 25 : 40) : ""}</h6>
              </CardBody>
              }
            
          </Link>
        </Card>
      </GridItem>
    );
});

export default MainContentsItem;